import { gql } from '@apollo/client'

const query = gql`
  query ShopifyCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      addresses(first: 250) {
        edges {
          node {
            id
            address1
            address2
            country
            city
            province
            provinceCode
            zip
            company
            name
            phone
            firstName
            lastName
          }
        }
      }
      defaultAddress {
        id
        address1
        address2
        country
        city
        province
        provinceCode
        zip
        company
        name
        phone
        firstName
        lastName
      }
    }
  }
`

/**
 *
 * NOTE: Separate from queryShopifyCustomer - Because of no-cache policy
 *
 * */
const queryShopifyLatestCustomer = (client, variables) => client.query({ query, variables, fetchPolicy: 'no-cache' })

export default queryShopifyLatestCustomer
